import { useState } from 'react';
import { Button } from "react-bootstrap";
import axios from 'axios';
//import { createUserWithEmailAndPassword } from 'firebase/auth';
//import { auth } from '../firebase';
import styles from './Register.css';
import { useNavigate, Link } from 'react-router-dom';
import { AiFillEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";
import Konsensus_Constants from '../constants/index.js';

export default function Register() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  let AXIOS_CONFIG;

  const handleRegister = async () => {
    try {
      const AXIOS_CONFIG = {
          headers: {
              'Content-Type':'application/json',
              'Accept': 'application/json'
          }
      }
      console.log("trying to register: "+Konsensus_Constants.FORUM_URL);
      let response = await axios.post(Konsensus_Constants.FORUM_URL+'/api/register', {email: email, username: username, password: password}, AXIOS_CONFIG);
      console.log(response);
      if( response.data.errors ){
        let message = "";
        for( var i=0; i<response.data.errors.length; i++ ){
           message += response.data.errors[i].detail + "\n"
        }
        alert(message);
      }
      if( response.data.error ){
        let message = "";
        message += response.data.error + "\n"
        alert(message);
      }
      if( response.data.user.id ){
        let response2 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/add-user', {useremail: email, username: username,
            password1: password, password2: password, userauth: 1}, AXIOS_CONFIG);
        if( response2.error ){
            alert(response2.error);
        }
        setShowConfirm(true);
      }
    } catch(error) {
      console.log(error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.length > 0
      ) {
        alert(
          `Failed: ${error.response.data.errors[0].detail}`
        );
      } else  if (
                     error.response &&
                     error.response.data &&
                     error.response.data.error
       ) {
         alert(
           `Failed: ${error.response.data.error}`
         );
      } else {
        alert("Registration failed (unknown error):"+error);
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
    if( showPassword ){
    }else{
    }
  };

  return (
  <div style={{
                height: '100%',
                display: 'grid',
                placeItems: 'center',
              }}>
    {showConfirm && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '20px',
          maxWidth: '400px',
          width: '90%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <h3 style={{ marginTop: 0, marginBottom: '15px', color: '#333' }}>
            Confirm E-Mail
          </h3>
          <p style={{ marginBottom: '20px', color: '#666', lineHeight: 1.5 }}>
            To confirm e-mail click on activate in e-mail received.
          </p>
          <div style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'flex-end'
          }}>
            <button
              onClick={() => navigate('/')}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: '500',
                backgroundColor: '#007bff',
                color: 'white'
              }}
            >
              Go to Login
            </button>
            <button
              onClick={() => setShowConfirm(false)}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: '500',
                backgroundColor: '#6c757d',
                color: 'white'
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )}
    <div style={{
                  flex: 1,
                  align: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginHorizontal: 22,
                }}>
      <img
         src={require('../assets/images/logo.png')}
         style={{
            height: 240,
            width: 340,
            marginBottom: 12,
         }}
      />
      <h2>Register</h2>
      <div><input placeholder="Username" className="input-rounded" type="username"
        onChange={e => setUsername(e.target.value)} /></div>
      <div><input placeholder="Email" className="input-rounded" type="email"
        onChange={e => setEmail(e.target.value)} /></div>
      <div>
       <input placeholder="Password" type="password" className="input-rounded" style={{width:"90%"}} type={showPassword ? 'text' : 'password'}
          onChange={e => setPassword(e.target.value)} />
          {showPassword ? (
            <AiFillEyeInvisible onClick={togglePasswordVisibility}/>
          ) : (
            <AiFillEye onClick={togglePasswordVisibility}/>
          )}
      </div>
      <Button onClick={handleRegister} className="input-rounded2">Register</Button>
      <p>Already have an account? <Link to="/">Login</Link></p>
      <p><Link to="/forgotten_password">Forgotten Password</Link></p>
    </div>
  </div>
  );
}